module.exports = __webpack_public_path__ + "media/IBMPlexSans-SemiBold.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/IBMPlexSans/IBMPlexSans-SemiBold.eot
// module id = 538
// module chunks = 58